import type { ButtonHTMLAttributes } from 'react';
import styles from './Button.module.css';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & { active?: boolean };

export default function Button({
  active,
  className,
  children,
  type,
  ...rest
}: Props) {
  const cls = [styles.pill, active ? styles.active : '', className ?? '']
    .filter(Boolean)
    .join(' ');
  return (
    <button type={type ?? 'button'} className={cls} {...rest}>
      {children}
    </button>
  );
}
